export class AuthorizationKeys {
    static platform: string = 'pos_platform';
    static lang: string = 'lang';
    static isQA: string = 'isQA';
    static disableInactivityTimer: string = 'disable_timer';
}

export class ErrorCodes {
    static invalidEnvironment: string = 'InvalidEnvironment';
    static kioskNotRegistered = "KioskNotRegistered";
    static kioskInvalidRegistration = "KioskInvalidRegistration";
}

export class StorageKeys {
    static authentication: string = "authentication";
}

